import { useQuery } from "@tanstack/react-query";
import { prescriptionAPI } from "@/lib/prescription-api";

export const useSpecialists = () => {
  return useQuery({
    queryKey: ["specialists"],
    queryFn: () => prescriptionAPI.getSpecialists(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
